import { useEffect } from 'react'
import { setModalLoading, setType } from 'src/app/modal'
import { useAppDispatch } from './useRTK'

type UseModalLoadingProps = {
  isLoading: boolean
  isSuccess: boolean
  isError: boolean
}

// Use this hook if you want the Parent of Modal knows that the Modal is loading
// Parent can access the loading state via "selectModalLoading" in Redux Store
const useModalLoading = ({
  isLoading,
  isSuccess,
  isError,
}: UseModalLoadingProps) => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(setModalLoading(isLoading))
    if (isSuccess || isError) {
      dispatch(setType({ type: null }))
    }
  }, [dispatch, isLoading, isSuccess, isError])
}

export default useModalLoading
